import React from "react";
import { useTranslation } from "react-i18next";
import { Accordion } from "components/Accordian/Accordian";
import moneyBag from "../../assets/FAQ/emojione-monotone_money-bag.svg";
import register from "../../assets/FAQ/mdi_register-outline.svg";
import invite from "../../assets/FAQ/mingcute_invite-line.svg";
import solar from "../../assets/FAQ/solar_money-bag-outline.svg";
import member from "../../assets/FAQ//tdesign_member.svg";
import money from "../../assets/FAQ/tdesign_money.svg";

export const FAQ = () => {
  const { t } = useTranslation();
  // const { auth } = useAuth();
  const items = [
    {
      key: 1,
      title: t("home.faq.title"),
      description: t("home.faq.description"),
      icon: moneyBag,
    },
    {
      key: 2,
      title: t("home.faq.HowdoIbecome"),
      description: t("home.faq.Tobecomeamember"),
      icon: member,
    },
    {
      key: 3,
      title: t("home.faq.CanIregister"),
      description: t("home.faq.Noeachmember"),
      icon: register,
    },

    {
      key: 4,
      title: t("home.faq.Isthereacost"),
      description: t("home.faq.NoBeing"),
      icon: money,
    },

    {
      key: 5,
      title: t("home.faq.HowdoIbenefit"),
      description: t("home.faq.Inaddition"),
      icon: solar,
    },

    {
      key: 6,
      title: t("home.faq.Idontseem"),
      description: t("home.faq.Aftersuccessfully"),
      icon: invite,
    },
  ];

  return (
    <section id="faq" className="py-16 scroll-mt-24 bg-canvas sm:py-24">
      <div className="grid gap-10 px-4 mx-auto max-w-7xl sm:px-6 lg:grid-cols-12 lg:gap-12 lg:px-8">
        <div className="lg:col-span-4">
          <div className="lg:sticky lg:top-28">
            <p className="zs-eyebrow">FAQ</p>
            <h1 className="mt-1 text-3xl font-bold tracking-tight font-display text-ink sm:text-4xl">
              Frequently Asked Question
            </h1>
            <p className="max-w-md mt-4 text-base leading-relaxed text-ink-2">
              We connect top sample providers and partners to new research projects and seamless.
            </p>
          </div>
        </div>
        <div className="lg:col-span-8">
          <div className="overflow-hidden divide-y zs-card divide-line">
            {items.map((item) => (
              <Accordion key={item.key} title={item.title} description={item.description} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
